export const replacePlaceholders = (
  template: string,
  values: Record<string, any> = {}
): string => {
  return template.replace(/\*\*([^*]+)\*\*/g, (match, key) => {
    return typeof values[key] !== 'undefined' ? values[key] : match
  })
}
